import { createEffectHook, TypedEvent } from '@rehaje/core'

import type { EventNode } from './TypedNode'
import type { TRecord } from '@rehaje/shared'

/**
 * EventNode 被执行指定事件时触发
 */
export class EventTriggerEvent extends TypedEvent<EventNode, TRecord> {
  type = 'onEventTrigger' as const
}

export const { onEventTrigger, onEventTriggerCapture } =
  createEffectHook(EventTriggerEvent)

declare global {
  export interface RehajeTypedEvents {
    onEventTrigger: EventTriggerEvent
  }
}
